import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { References } from '../../../types/Content';

type ContentClaims = {
  errorLoadingClaims: boolean;
  errorMessage: string;
  claims: References[];
  retries: number;
};
type Claims = {
  isLoading: boolean;
  map: Record<string, ContentClaims>;
  previewClaims?: References[];
};

export const contentClaimsStateSegment = stateSegmentWithReset<Claims>({
  isLoading: false,
  map: {},
  previewClaims: [],
});
contentClaimsStateSegment.debugLabel = 'contentClaimsStateSegment';
